import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    StoreType,
    SilDeviceType,
    SilDeviceFilters,
    SortSilDevices,
    setSilModelDevicesAccountDeviceIds,
    setSilModelDevicesAccountDeviceSort,
    setSilModelDevicesAccountDeviceFilters,
} from "client/store"
import {
    PageContent,
    Table,
    TableSearchWrapper,
    SortRows,
} from "client/components"

import SilDeviceSearch from "client/pages/search/silDeviceSearch"
import Columns from "./columns"

const AccountDevices = () => {
    const deviceList = useSelector((state: StoreType) => state.silModelDevices.accountDevices.deviceList)
    const deviceIds = useSelector((state: StoreType) => state.silModelDevices.accountDevices.deviceIds)
    const sortColumn = useSelector((state: StoreType) => state.silModelDevices.accountDevices.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.silModelDevices.accountDevices.sortOrder)
    const filters = useSelector((state: StoreType) => state.silModelDevices.accountDevices.filters)

    const dispatch = useDispatch()

    useEffect(() => {
        const sortedIds = SortSilDevices(Object.values(deviceList), sortColumn, sortOrder, filters)
        dispatch(setSilModelDevicesAccountDeviceIds(sortedIds))
    }, [deviceList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof SilDeviceType, order) => {
        dispatch(setSilModelDevicesAccountDeviceSort(column, order))
    }

    const onFilter = (newFilters: SilDeviceFilters) => {
        dispatch(setSilModelDevicesAccountDeviceFilters(newFilters))
    }

    const columns = Columns()

    return (
        <PageContent>
            <TableSearchWrapper>
                <SilDeviceSearch
                    id="accountDevices"
                    filters={filters}
                    onFilter={onFilter}
                />
            </TableSearchWrapper>
            <Table
                columns={columns}
                dataList={deviceList}
                dataIds={deviceIds}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
                rowSize="md"
                showPagination
                onSort={onSort}
            />
        </PageContent>
    )
}
export default AccountDevices
